import "./utils/nativeFetch";
import React from "react";
import { ClerkProvider } from "@clerk/clerk-react";
import { Provider } from "react-redux";
import { store, persistor } from "./store.ts";
import { PersistGate } from "redux-persist/integration/react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import ls from "@livesession/browser";
import "./index.css";
import Routes from "./routes.tsx";
import config from "./config.ts";
import { ClerkTokenInitializer } from "./components/ClerkTokenInitializer.tsx";
import { loadAnalytics } from "./utils/rudderstack.ts";
import { restoreNativeFetch, restoreNativeXhr } from "./utils/nativeFetch.ts";

loadAnalytics();
// Rudderstack instruments fetch/XHR; restore the native fetch so API calls bypass instrumentation.
restoreNativeFetch();
restoreNativeXhr();

// Only initialize LiveSession in staging and production environments
if (config.environment !== "development") {
  ls.init(config.liveSessionTrackId, {
    rootHostname: ".helloprenup.com",
    keystrokes: false,
  });

  // Track the first page view to start session recording
  ls.newPageView();
}

Sentry.init({
  dsn: config.sentryDsn,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const root = document.getElementById("root");
if (!root) throw new Error("No root element found");

createRoot(root).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={config.clerkKey || ""} afterSignOutUrl="/">
      <ClerkTokenInitializer>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Routes />
          </PersistGate>
        </Provider>
      </ClerkTokenInitializer>
    </ClerkProvider>
  </React.StrictMode>,
);
